<script lang="ts" setup>
import {ReccoRecommendationTypeDTO} from '@/ts/types/dto/recco/recommendation.dto';
import {computed} from 'vue';
import {useI18n} from 'vue-i18n';
import {mediaLabelWithDuration} from '@/ts/utils/recco-label-keys';

const props = withDefaults(defineProps<{
  type: ReccoRecommendationTypeDTO;
  /** Length in seconds, as the backend sends it. Null or absent prints the kind alone. */
  duration?: number | null;
}>(), {
  duration: null,
});

const {t: $t} = useI18n();

const labelLanguageKey = computed((): string => {
  return {
    [ReccoRecommendationTypeDTO.Article]: 'recco_media_type_articles',
    [ReccoRecommendationTypeDTO.Audio]: 'recco_media_type_audios',
    [ReccoRecommendationTypeDTO.Video]: 'recco_media_type_videos',
    [ReccoRecommendationTypeDTO.Questionnaire]: 'recco_media_type_questionnaire',
    [ReccoRecommendationTypeDTO.TrackingActivity]: 'recco_media_type_tracking_activity',
  }[props.type];
});

// "Listen · 12 min" (IPD-3375): the length rides behind the kind, through the same helper every
// other card uses, so this one cannot round or separate differently.
const label = computed((): string => mediaLabelWithDuration($t(labelLanguageKey.value), props.duration, $t));
</script>

<template>
  <div class="media-type-and-duration">
    <span
      v-if="labelLanguageKey"
      class="media-type-label"
    >
      {{ label }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
.media-type-and-duration {
  color: var(--Neutral-UI-neutral-ui-60);
}

.media-type-label {
  @include font-body-sm;
}

</style>
